import dayjs from "dayjs";
import {
  type HotelsSortValue,
  type THotelFormFieldValues,
} from "./types/types";
import { HotelsSortOptions, SortOrder, TravelPurpose } from "./types/enums";

export const initialHotelsValues: THotelFormFieldValues = {
  destination: null,
  dates: {
    checkIn: dayjs().startOf("day").toDate(),
    checkOut: dayjs().startOf("day").add(1, "day").toDate(),
  },
  rooms: [
    {
      adults: 1,
      children: 0,
      childrenAges: [] as number[],
    },
  ],
  travelPurpose: TravelPurpose.LEISURE,
};

export const initialSortValue: HotelsSortValue = {
  field: HotelsSortOptions.RECOMMENDED,
  order: SortOrder.ASC,
};
